import React from 'react';
import classNames from 'classnames';

import StarRating from 'buyside/components/presentation/StarRating/starRating';

import styles from './ideaCommunityRatingStyles';

const IdeaCommunityRating = ({ style = null, rating }) => {
  let userRating,
    ratingCount = 0;

  if (rating) {
    userRating = Number(rating.averageRating);
    ratingCount = rating.userRatingCount;
  }

  const votesNeeded = 4 - ratingCount;

  return (
    <div className={classNames(styles.communityRating, style)}>
      {ratingCount > 3 ? (
        <StarRating id={rating.id} rating={userRating} ratingCount={ratingCount} />
      ) : (
        <figure className={styles.naText}>
          {votesNeeded} vote{votesNeeded === 1 ? '' : 's'} needed
        </figure>
      )}
    </div>
  );
};

export default IdeaCommunityRating;
